import { Component, ViewChild, ElementRef, Input, ViewEncapsulation, Output, EventEmitter, AfterViewChecked, OnDestroy, HostListener, ApplicationRef, ComponentFactoryResolver, Injector, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import 'slickgrid/lib/jquery.event.drag-2.3.0';
//import 'slickgrid/lib/jquery.event.drop-2.3.0';
//import 'slickgrid/lib/jquery-ui-1.9.2';
//import 'slickgrid/lib/jquery-ui-1.12.1';
//import 'jquery-ui/ui/widgets/sortable.js'
import 'slickgrid/slick.core';
import 'slickgrid/slick.grid';
import 'slickgrid/slick.editors';
import 'slickgrid/slick.dataview';
import 'slickgrid/plugins/slick.checkboxselectcolumn';
import 'slickgrid/plugins/slick.rowselectionmodel';
import 'slickgrid/slick.groupitemmetadataprovider';
import 'slickgrid-column-data-autosize/dist/slick.autocolumnsize';
import * as Popper from 'popper.js/dist/umd/popper';
//import 'numeral/numeral';
//import 'numeral/locales';

import { IAngularEditor } from 'app/slick-grid/interfaces/angular-editor';
import { EventArgs } from 'app/slick-grid/models/event-args';
import { IDataSorter } from 'app/slick-grid/interfaces/data-sorter';
import { DataSorter } from 'app/slick-grid/models/data-sorter';
import { ISlickGridColumn } from 'app/slick-grid/interfaces/slick-grid-column'
import { DropdownFilterType } from 'app/slick-grid/interfaces/dropdown-filter-type';
import { OnDropdownFilteredEventArgs } from 'app/slick-grid/models/on-dropdown-filtered-event-args';

@Component({
    selector: 'slick-grid',
    template: '<div #grid class="slickgrid"></div>',
    styleUrls: ['./slick-grid.component.css', '../../../node_modules/slickgrid/slick.grid.css', '../../../node_modules/slickgrid/slick-default-theme.css'],
    encapsulation: ViewEncapsulation.None
})
export class SlickGridComponent implements AfterViewChecked, OnDestroy {
    constructor(private readonly appRef: ApplicationRef, private readonly resolver: ComponentFactoryResolver, private readonly injector: Injector, public readonly renderer: Renderer2, private readonly translateService: TranslateService, private readonly elementRef: ElementRef) {
        this.onClick = new EventEmitter<EventArgs<Slick.OnClickEventArgs<any>>>();
        this.onDblClick = new EventEmitter<EventArgs<Slick.OnDblClickEventArgs<any>>>();
        this.onActiveCellChanged = new EventEmitter<EventArgs<Slick.OnActiveCellChangedEventArgs<any>>>();
        this.onActiveCellPositionChanged = new EventEmitter<EventArgs<Slick.OnActiveCellPositionChangedEventArgs<any>>>();
        this.onSort = new EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>();
        this.onSorted = new EventEmitter<void>();
        this.onBeforeEditCell = new EventEmitter<EventArgs<Slick.OnBeforeEditCellEventArgs<any>>>(false);
        this.onCellChange = new EventEmitter<EventArgs<Slick.OnCellChangeEventArgs<any>>>();
        this.onViewportChanged = new EventEmitter<EventArgs<Slick.OnViewportChangedEventArgs<any>>>();
        this.onSelectedRowsChanged = new EventEmitter<EventArgs<Slick.OnSelectedRowsChangedEventArgs<any>>>();
        this.onHeaderCellRendered = new EventEmitter<EventArgs<Slick.OnHeaderCellRenderedEventArgs<any>>>();
        this.onDropdownFiltered = new EventEmitter<EventArgs<OnDropdownFilteredEventArgs<any>>>();
        //this.onInitialized = new EventEmitter<EventArgs<Slick.Grid<any>>>();
        this.onColumnsResized = new EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>();
        //this.onColumnsReordered = new EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>();

        this.filteredColumns = [];

        //this.translateService.use(sessionStorage.getItem('userLocale'));
        //console.log(sessionStorage.getItem('userLocale'));
    }

    @ViewChild('grid')
    private gridRef: ElementRef;

    //private gridWidth: number;
    //@Input()
    //set width(value: number) {
    //    if (value)
    //        this.gridWidth = value;
    //}
    //get width(): number {
    //    return this.gridWidth;
    //}

    //private gridHeight: number;
    //@Input()
    //set height(value: number) {
    //    if (value)
    //        this.gridHeight = value;
    //}
    //get height(): number {
    //    return this.gridHeight;
    //}

    private data: Slick.Data.DataView<any> | any[];
    @Input('data')
    set dataInput(data: Slick.Data.DataView<any> | any[]) {
        this.removeDataViewListeners();

        this.data = data || [];
        if (this.data instanceof Slick.Data.DataView) {
            const dataView = this.data as Slick.Data.DataView<any>;
            dataView.onRowCountChanged.subscribe(this.onDataViewRowCountChanged);
            dataView.onRowsChanged.subscribe(this.onDataViewRowsChanged);
        }

        if (!this.grid)
            return;

        if (this.data instanceof Slick.Data.DataView)
            this.grid.setData(this.data as Slick.Data.DataView<any>, true);
        else
            this.grid.setData(this.data as any[], true);
        this.grid.render();
    }

    private columns: Slick.Column<any>[];
    @Input('columns')
    set columnsInput(columns: Slick.Column<any>[]) {
        const setColumns = (): void => {
            this.columns = columns;
            if (this.grid)
                this.grid.setColumns(this.columns);
            if (this.filteredColumns && this.filteredColumns.length)
                this.filteredColumns = [];
        };

        if (!columns) {
            columns = [];
            setColumns();
            return;
        }

        setColumns();

        setTimeout(() => {
            this.translateService.get(columns.map(c => c.name)).subscribe(names => {
                columns.forEach(c => c.name = names[c.name]);
                setColumns();
            });
        },1);
    }

    private options: Slick.GridOptions<any>;
    @Input('options')
    set optionsInput(options: Slick.GridOptions<any>) {
        this.options = options || {};
        if (this.grid)
            this.grid.setOptions(this.options);
    }

    private css: string[];
    @Input()
    set cssClasses(css: string[]) {
        if (!this.gridRef) {
            this.css = css;
            return;
        }

        if (this.css)
            this.css.forEach(c => this.gridRef.nativeElement.classList.remove(c));

        this.css = css;

        if (this.css)
            this.css.forEach(c => this.gridRef.nativeElement.classList.add(c));
    }

    private cellStyles: { [key: string]: Slick.CellCssStylesHash }
    @Input()
    set cellCssStyles(value: { [key: string]: Slick.CellCssStylesHash }) {
        this.removeCellStyles();

        this.cellStyles = value;

        this.setCellStyles();
    }

    private selection: Slick.SelectionModel<any, Slick.Range[]>;
    @Input()
    set selectionModel(value: Slick.SelectionModel<any, Slick.Range[]>) {
        this.selection = value;

        if (this.grid)
            this.grid.setSelectionModel(value);
    }

    private sorter: IDataSorter<any>;
    @Input()
    set dataSorter(value: IDataSorter<any>) {
        this.sorter = value;
    }

    private grid: Slick.Grid<any>;

    private pluginsToRegister: Slick.Plugin<any>[];

    private gridInitiating: boolean;

    @Output()
    private readonly onClick: EventEmitter<EventArgs<Slick.OnClickEventArgs<any>>>;

    @Output()
    private readonly onDblClick: EventEmitter<EventArgs<Slick.OnDblClickEventArgs<any>>>;

    @Output()
    private readonly onActiveCellChanged: EventEmitter<EventArgs<Slick.OnActiveCellChangedEventArgs<any>>>;

    @Output()
    private readonly onActiveCellPositionChanged: EventEmitter<EventArgs<Slick.OnActiveCellPositionChangedEventArgs<any>>>;

    @Output()
    private readonly onSort: EventEmitter<EventArgs<Slick.OnSortEventArgs<any>>>;

    @Output()
    private readonly onSorted: EventEmitter<void>;

    @Output()
    private readonly onBeforeEditCell: EventEmitter<EventArgs<Slick.OnBeforeEditCellEventArgs<any>>>;

    @Output()
    private readonly onCellChange: EventEmitter<EventArgs<Slick.OnCellChangeEventArgs<any>>>;

    @Output()
    private readonly onViewportChanged: EventEmitter<EventArgs<Slick.OnViewportChangedEventArgs<any>>>;

    @Output()
    private readonly onSelectedRowsChanged: EventEmitter<EventArgs<Slick.OnSelectedRowsChangedEventArgs<any>>>;

    @Output()
    private readonly onHeaderCellRendered: EventEmitter<EventArgs<Slick.OnHeaderCellRenderedEventArgs<any>>>;

    @Output()
    private readonly onDropdownFiltered: EventEmitter<EventArgs<OnDropdownFilteredEventArgs<any>>>;

    @Output()
    private readonly onColumnsResized: EventEmitter<EventArgs<Slick.OnColumnsResizedEventArgs<any>>>;

    /*@Output()
    private readonly onColumnsReordered: EventEmitter<EventArgs<Slick.OnColumnsReorderedEventArgs<any>>>;*/

    //@Output()
    //private readonly onInitialized: EventEmitter<EventArgs<Slick.Grid<any>>>;

    get htmlElement(): HTMLElement {
        return this.elementRef.nativeElement;
    }

    private filteredColumns: string[];

    ngAfterViewChecked(): void {
            if (this.grid || this.gridInitiating)
                return;

            this.gridInitiating = true;

            this.cssClasses = this.css;

            this.grid = new Slick.Grid(this.gridRef.nativeElement, this.data, [], this.options);
            this.grid.onClick.subscribe((e, data) => this.onClick.emit(new EventArgs(e, data)));
            this.grid.onDblClick.subscribe((e, data) => this.onDblClick.emit(new EventArgs(e, data)));
            this.grid.onActiveCellChanged.subscribe((e, data) => this.onActiveCellChanged.emit(new EventArgs(e, data)));
            this.grid.onActiveCellPositionChanged.subscribe((e, data) => this.onActiveCellPositionChanged.emit(new EventArgs(e, data)));
            //this.grid.onSort.subscribe((e, data) => this.onSort.emit(new EventArgs(e, data)));
            this.grid.onSort.subscribe((e, data) => this.sortData(e, data));
            this.grid.onBeforeEditCell.subscribe((e, data) => {
                this.onBeforeEditCell.emit(new EventArgs(e, data));
                return !e.isPropagationStopped();
            });
            this.grid.onCellChange.subscribe((e, data) => this.onCellChange.emit(new EventArgs(e, data)));
            this.grid.onViewportChanged.subscribe((e, data) => this.onViewportChanged.emit(new EventArgs(e, data)));
            this.grid.onSelectedRowsChanged.subscribe((e, data) => this.onSelectedRowsChanged.emit(new EventArgs(e, data)));
            this.grid.onHeaderCellRendered.subscribe(this.onGridHeaderCellRendered);
            this.grid.onHeaderCellRendered.subscribe((e, data) => this.onHeaderCellRendered.emit(new EventArgs(e, data)));
            this.grid.onColumnsResized.subscribe((e, data) => this.onColumnsResized.emit(new EventArgs(e, data)));
            this.grid.onColumnsReordered.subscribe((e, data) => this.onColumnsResized.emit(new EventArgs(e, data)));
            this.grid.setColumns(this.columns);
            if (this.selection)
                this.grid.setSelectionModel(this.selection);
            this.grid.registerPlugin(new Slick['AutoColumnSize']());
            this.setCellStyles();
            this.registerPlugins();

            if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
                // let headers = document.getElementsByClassName('slick-header-column');
                // for (let i = 0; i < headers.length; i++){
                //     headers[i].classList.add('box-sizing-border-box')
                // }
            }


        // For change in node modules

        /*var header = $("<div class='ui-state-default slick-header-column' />")
            .html("<span class='slick-column-name'>" + m.name + "</span>")
            .outerWidth(m.width - headerColumnWidthDiff)
            .attr("id", "" + uid + m.id)
            .attr("title", m.toolTip || "")
            .data("column", m)
            .addClass(m.headerCssClass || "")
            .appendTo($headers);*/

        //this.onInitialized.emit(new EventArgs(new Slick.EventData(), this.grid));
        this.gridInitiating = false;
    }

    ngOnDestroy(): void {
        this.destroyGrid();
    }

    destroyGrid = (): void => {
        if (!this.grid)
            return;

        this.removeDataViewListeners();

        this.grid.destroy();
        this.grid = null;
    }

    @HostListener('window:resize')
    resizeGrid = (): void => {
        if (this.grid)
            this.grid.resizeCanvas();
    }

    initializeAngularEditor = (editor: IAngularEditor): void => {
        editor.initialize(this.appRef, this.resolver, this.injector, this.renderer);
    }

    getActiveCell = (): Slick.Cell => {
        return this.grid.getActiveCell();
    }

    setActiveCell = (row: number, cell: number, suppressActiveCellChangedEvent?: boolean): void => {
        (this.grid as any).setActiveCell(row, cell, null, null, suppressActiveCellChangedEvent);
    }

    scrollCellIntoView = (row: number, cell: number, doPaging: boolean): void => {
        this.grid.scrollCellIntoView(row, cell, doPaging);
    }

    getCellNode = (row: number, cell: number): HTMLElement => {
        return this.grid ? this.grid.getCellNode(row, cell) : null;
    }

    registerPlugin = (plugin: Slick.Plugin<any>): void => {
        if (!this.pluginsToRegister)
            this.pluginsToRegister = [];

        this.pluginsToRegister.push(plugin);
        this.registerPlugins();
    }

    setOptions = (options: Slick.GridOptions<any>): void => {
        this.grid.setOptions(options);
    }

    invalidateAllRows = (options: Slick.GridOptions<any>): void => {
        this.grid.invalidateAllRows();
    }

    getColumnIndex = (id: string): number => {
        return this.grid.getColumnIndex(id);
    }

    editActiveCell = (editor?: Slick.Editors.Editor<any>): void => {
        this.grid.editActiveCell(editor);
    }

    invalidate = (): void => {
        this.grid.invalidate();
    }

    invalidateRow = (row: number): void => {
        this.grid.invalidateRow(row);
    }

    render = (): void => {
        this.grid.render();
    }

    resizeCanvas = (): void => {
        this.grid.resizeCanvas();
    }

    setColumns = (columns): void => {
        this.grid.setColumns(columns);
    }

    getSelectedRows = (): number[] => {
        return this.grid.getSelectedRows();
    }

    setSelectedRows = (rows: number[]): void => {
        this.grid.setSelectedRows(rows);
    }

    getRenderedRange = (viewportTop?: number, viewportLeft?: number): Slick.Viewport => {
        return this.grid.getRenderedRange(viewportTop, viewportLeft);
    }

    getDataItem = (index: number): any => {
        return this.grid.getDataItem(index);
    }

    updateRow = (row: number): void => {
        this.grid.updateRow(row);
    }

    getColumns = (): Slick.Column<any>[] => {
        return this.grid && this.grid.getColumns();
    }

    syncGridCellCssStyles = (key: string): void => {
        if (this.data instanceof Slick.Data.DataView)
            (this.data as Slick.Data.DataView<any>).syncGridCellCssStyles(this.grid, key);
    }

    syncGridSelection = (preserveHidden: boolean): void => {
        if(this.data instanceof Slick.Data.DataView)
            (this.data as Slick.Data.DataView<any>).syncGridSelection(this.grid, preserveHidden);
    }

    private removeDataViewListeners = (): void => {
        if (this.data instanceof Slick.Data.DataView) {
            const dataView = this.data as Slick.Data.DataView<any>;
            dataView.onRowCountChanged.unsubscribe(this.onDataViewRowCountChanged);
            dataView.onRowsChanged.unsubscribe(this.onDataViewRowsChanged);
        }
    }

    private removeCellStyles = (): void => {
        if (!this.grid || !this.cellStyles)
            return;

        for (let key in this.cellStyles)
            if (this.cellStyles.hasOwnProperty(key))
                this.grid.removeCellCssStyles(key);
    }

    private setCellStyles = (): void => {
        if (!this.grid || !this.cellStyles)
            return;

        for (let key in this.cellStyles)
            if (this.cellStyles.hasOwnProperty(key))
                this.grid.setCellCssStyles(key, this.cellStyles[key]);
    }

    private onDataViewRowCountChanged = (/*e: Slick.EventData, args: Slick.Data.OnRowCountChangedEventData*/): void => {
        this.grid.updateRowCount();
        this.grid.render();
    }

    private onDataViewRowsChanged = (e: Slick.EventData, args: Slick.Data.OnRowsChangedEventData): void => {
        this.grid.invalidateRows(args.rows);
        this.grid.render();
    }

    private registerPlugins = (): void => {
        if (!this.grid || !this.pluginsToRegister)
            return;

        this.pluginsToRegister.forEach(p => this.grid.registerPlugin(p));
        this.pluginsToRegister = null;
    }

    private sortData = (event: Slick.EventData | DOMEvent, args: Slick.OnSortEventArgs<any>): void => {
        if (this.onSort.observers.length > 0) {
            this.onSort.emit(new EventArgs(event, args));
            return;
        }
        const sorter = this.sorter || new DataSorter<any>();
        sorter.sort(args);

        this.onSorted.emit();
    }

    private setDropdownFilter = (column: ISlickGridColumn<any>, headerCell: HTMLElement, translates: any): void => {
        const renderer = column.dropdownFilter.renderer;
        //this.renderer.addClass(headerCell, 'dropdown');
        //renderer.addClass(headerCell, 'd-flex');
        if (this.filteredColumns.indexOf(column.field) >= 0)
            renderer.addClass(headerCell, 'filtered');

        const btn = renderer.createElement('button');
        renderer.addClass(btn, 'dropdown-toggle');
        renderer.addClass(btn, 'dropdown-filter-btn');
        renderer.appendChild(headerCell, btn);

        let dropdownVisible = false;
        renderer.listen(btn, 'click', e => {
            e.stopPropagation();

            if (dropdownVisible)
                return;

            const dropdown = renderer.createElement('div');
            renderer.addClass(dropdown, 'dropdown-menu');

            let removeListener: () => void;
// ReSharper disable once JoinDeclarationAndInitializerJs
            let dropdownPopper: Popper;
            const hideDropdown = (): void => {
                removeListener();
                renderer.removeClass(dropdown, 'show');
                dropdownPopper.destroy();
                renderer.removeChild(column.dropdownFilter.dropdownContainer, dropdown);
                dropdownVisible = false;
            };
            const onFilter = (type: DropdownFilterType, value?: any) => {
                hideDropdown();

                const index = this.filteredColumns.indexOf(column.field);
                if (type === DropdownFilterType.All) {
                    renderer.removeClass(headerCell, 'filtered');
                    if (index >= 0)
                        this.filteredColumns.splice(index, 1);
                } else {
                    renderer.addClass(headerCell, 'filtered');
                    if (index < 0)
                        this.filteredColumns.push(column.field);
                }

                this.onDropdownFiltered.emit(new EventArgs(new Slick.EventData(), new OnDropdownFilteredEventArgs(column, type, value)));
            };
            const appendDropdownItem = (text: string, onClick: () => void): void => {
                const menuItem = renderer.createElement('button');
                renderer.setAttribute(menuItem, 'type', 'button');
                renderer.addClass(menuItem, 'dropdown-item');
                renderer.appendChild(menuItem, renderer.createText(text));
                renderer.listen(menuItem, 'click', onClick);
                renderer.appendChild(dropdown, menuItem);
            };

            appendDropdownItem(translates.All, () => onFilter(DropdownFilterType.All));
            const sorter = new DataSorter();
            let hasEmpty = false;
            let data = this.data instanceof Slick.Data.DataView ? (this.data as Slick.Data.DataView<any>).getItems() : this.data;
            if (column.dropdownFilter.sourceFilter != null)
                data = data.filter(i => column.dropdownFilter.sourceFilter(i));
            data.sort((a, b) => {
                    const formatter = (column.dropdownFilter.sortFormatter || (v => v));
                    return sorter.compare(formatter(a[column.field]), formatter(b[column.field]));
                })
                .map(i => {
                    const value = i[column.field];
                    const text = column.dropdownFilter.displayFormatter != null ? column.dropdownFilter.displayFormatter(value) : value;

                    if (text)
                        return { text, value };

                    hasEmpty = true;
                    return null;
                })
                .filter((n, i, list) => n && list.findIndex(n1 => n1 && n1.text === n.text) === i)
                .forEach(n => appendDropdownItem(n.text, () => onFilter(DropdownFilterType.ByValue, n.value)));
            if (hasEmpty) {
                appendDropdownItem(translates.Blank_Are, () => onFilter(DropdownFilterType.Blank));
                appendDropdownItem(translates.NonBlank_Are, () => onFilter(DropdownFilterType.NonBlank));
            }

            renderer.appendChild(column.dropdownFilter.dropdownContainer, dropdown);
            dropdownPopper = new Popper(headerCell, dropdown, { placement: 'bottom-start' });
            renderer.addClass(dropdown, 'show');
            //renderer.setAttribute(headerCell, 'data-toggle', 'dropdown');
            //$(btn).dropdown().dropdown('toggle');

            setTimeout(() => {
                removeListener = renderer.listen('body', 'mousedown', (event: MouseEvent) => {
                    if (!(event.target instanceof HTMLElement) || !(event.target as HTMLElement).classList.contains('dropdown-item'))
                        hideDropdown();
                });
            }, 1);

            dropdownVisible = true;
        });
    }

    private onGridHeaderCellRendered = (event: DOMEvent, args: Slick.OnHeaderCellRenderedEventArgs<any>) => {
        const column = args.column as ISlickGridColumn<any>;
        if (!column)
            return;

        if(column.dropdownFilter)
            this.translateService.get(['All', 'Blank_Are', 'NonBlank_Are']).subscribe(t => this.setDropdownFilter(column, args.node, t));

        if (column.selectAll && column.selectAll.allSelectable) {
            const input = this.renderer.createElement('input') as HTMLInputElement;
            input.type = 'checkbox';
            this.renderer.listen(input,
                'change',
                () => {
                    let items: any[];
                    if (this.data instanceof Slick.Data.DataView)
                        items = this.data.getItems();
                    else
                        items = this.data;
                    for (const item of items)
                        item[column.field] = input.checked;

                    if (!this.grid)
                        return;

                    this.grid.invalidate();
                    this.grid.render();

                    if (column.selectAll.onSelectionChanged)
                        column.selectAll.onSelectionChanged();
                });

            const container = args.node.querySelector('.slick-column-name');
            this.renderer.appendChild(container, input);
            this.renderer.addClass(container, 'text-center');
        }

        //$(args.data.node).on('hidden.bs.dropdown',
        //    () => {
        //        dropdownVisible = false;

        //        //$(btn).dropdown('destroy');
        //        this.renderer.removeChild('body', dropdown);
        //        //this.renderer.removeAttribute(btn, 'data-toggle');
        //    });
    }
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/slick-grid.component.ts